import gql from 'graphql-tag'

export const GET_THERMO = gql`
  query ThermoTypes($filter: GetLookupWithFilterInput) {
    thermoTypes(filter: $filter) {
      isSuccessful
      message
      thermoTypes {
        data {
          companyId
          srcTable
          srcColumn
          text
          hasRelation
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const THERMO_MUTATION_CREATE = gql`
  mutation CreateThermoType($input: CreateLookupInputSimple!) {
    createThermoType(input: $input) {
      isSuccessful
      message
      thermoType {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`

export const THERMO_MUTATION_DELETE = gql`
  mutation DeleteThermoType($input: DeleteLookupInputSimple!) {
    deleteThermoType(input: $input) {
      isSuccessful
      message
      thermoType {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`

export const THERMO_MUTATION_UPDATE = gql`
  mutation UpdateThermoType($input: UpdateLookupInputSimple!) {
    updateThermoType(input: $input) {
      isSuccessful
      message
      thermoType {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }
`
